import { useContext, Context } from 'react';
import { MeContext, MeContextData } from 'contexts/me/context';

export const useMe = () => {
  return useContext(MeContext as Context<MeContextData>);
};
